import React, { Fragment } from "react";
import Divider from "../../SimpleForm/UI/Divider";
import "./style.scss";

const renderValues = (values) => {
  if (
    values &&
    typeof values === "object" &&
    !Array.isArray(values) &&
    values != null
  ) {
    return values["label"]; //return label for county objects
  } else if (values && values != null) {
    return values.map((val) => <span> {val.label} </span>); //for an array
  } else {
    return null;
  }
};

const fLabelResolver = (machineName) => {
  const fieldNames = {
    f1_number_workers:
      "Enter the estimated number of workers that will perform work at this place of employment under the LCA",
    f2_is_secondary_entity:
      "Indicate whether the worker(s) subject to this LCA will be placed with a secondary entity at this place of employment",
    f3_secondary_entity_name: "Legal Business name of secondary entity",
    f4_work_address_1: "Address 1",
    f5_work_address_2: "Address 2 (apartment/suite/floor and number)",
    f6_work_city: "City",
    f7_work_county_id: "County",
    f8_work_state_id: "State/District/Territory",
    f9_work_zip: "Postal Code",
    f10_nonimmigrant_wage_from: "Wage Rate Paid to Nonimmigrant Workers From",
    f10_nonimmigrant_wage_to: "Wage Rate Paid to Nonimmigrant Workers To",
    f10a_nonimmigrant_wage_per: "Wage Rate Paid to Nonimmigrant Workers Per",
    f11_prevailing_wage: "Prevailing Wage Rate",
    f11a_prevailing_wage_per: "Prevailing Wage Rate Per",
    f12_f13_f14_prevailing_wage_question:
      "Identify the source user for the prevailing wage (PW)",
    f12_is_dol_prevailing_wage:
      "Identify the source user for the prevailing wage (PW)",
    f12a_pwd_number: "Prevailing Wage Determination (PWD) tracking number",
    f13_is_oes_prevailing_wage: "OES Prevailing Wage",
    f14_non_oes_prevailing_wage: "Non OES Prevailing Wage",
    f13a_wage_level: "Wage Level",
    f13b_source_year: "Source Year",
    f14a_source_type: "Source Type",
    f14b_source_year_cba: "Source Year",
    f14b_source_year_notcba: "Source Year",
    f14c_survey_publisher: "Enter the name of the survey producer or publisher",
    f14d_survey_name: "Enter the title or name of the PW survey",
  };
  return fieldNames[machineName] || null;
};

const faLabelResolver = (machineName) => {
  const fieldNames = {
    supervisedSocCode: "SOC Code",
    supervisedSocTitle: "SOC Description",
  };
  return fieldNames[machineName] || null;
};
const appxALabelResolver = (machineName) => {
  const fieldNames = {
    worksiteCity: "City",
    worksiteState: "State",
    worksiteCountyTownship: "County",
    worksiteBlsArea: "BLS Area",
  };
  const getAllColumns = () => {
    return fieldNames;
  };
  return [fieldNames[machineName], getAllColumns];
};

const LabelResolver = (key) => {
  let obj = {
    "formUI9035Employment and Wage <br/>Information": fLabelResolver,
    "formUI9141Job Description": faLabelResolver,
    "formUI9141Additional Worksites": appxALabelResolver,
  };
  return obj[key] || null;
};

const renderRows = (fieldarray, formName) => {
  let key = formName + fieldarray.page_title;
  if (fieldarray && fieldarray.value) {
    return fieldarray.value.map((row) => {
      if (row["__typename"]) {
        delete row["__typename"];
      }

      let sorted_row = Object.keys(row).sort();
      let rowLength = Object.keys(row).length;
      let labelResolver = LabelResolver(key);

      // used to set the order of fields based on resolver's properties
      if (labelResolver && Array.isArray(labelResolver())) {
        sorted_row = Object.keys(labelResolver()[1]());
      }
      let rowItem = sorted_row.map((col, i) => {
        let label = labelResolver ? labelResolver(col) : null;
        if (
          label !== "f12_f13_f14_prevailing_wage_question" &&
          label !== null
        ) {
          let value = row[col];
          if (value && value !== "") {
            return (
              <Fragment key={i}>
                <div className="grid-row field-item">
                  <span className="grid-col-6 summary-label">{label}</span>
                  <span className="summary-answers grid-col-6">
                    {typeof value !== "object" ? value : renderValues(value)}
                  </span>
                </div>
                {(i + 1) % rowLength === 0 ? <Divider /> : null}
              </Fragment>
            );
          }
        }
      });
      return (
        <>
          {rowItem}
          <hr></hr>
        </>
      );
    });
  }
};

const FieldArraySummary = ({ obj, formName }) => {
  return <div>{renderRows(obj, formName)}</div>;
};

export { fLabelResolver };

export default FieldArraySummary;
